<template>
  <div class="messaging">
    <div class="container">
      <div class="new-badge" data-aos="fade-down" data-aos-duration="800">
        <span>NEW FEATURE</span>
      </div>

      <h1 data-aos="fade-up" data-aos-duration="1000">
        Multi-Channel Messaging <br />
        <span class="highlight">for Mirakl Marketplaces</span>
      </h1>

      <h3 data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
        Consolidate all customer messages from 450+ Mirakl marketplaces into one
        unified inbox
      </h3>

      <b-row class="features-row">
        <b-col lg="4" md="6" sm="12">
          <div
            class="feature-card"
            data-aos="zoom-in"
            data-aos-delay="300"
            data-aos-duration="800"
          >
            <div class="icon-wrapper">
              <img
                src="../../assets/images/icons/support.png"
                alt="Unified Inbox"
              />
            </div>
            <h4>Unified Inbox</h4>
            <p>
              No more logging into dozens of Mirakl back-ends. Manage all
              customer and operator messages from one efficient interface.
            </p>
          </div>
        </b-col>

        <b-col lg="4" md="6" sm="12">
          <div
            class="feature-card"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="800"
          >
            <div class="icon-wrapper">
              <img
                src="../../assets/images/icons/stars.png"
                alt="Better Scores"
              />
            </div>
            <h4>Boost Customer Satisfaction</h4>
            <p>
              Faster, more consistent responses directly improve your Customer
              Experience scores and seller quality metrics.
            </p>
          </div>
        </b-col>

        <b-col lg="4" md="12" sm="12">
          <div
            class="feature-card"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="800"
          >
            <div class="icon-wrapper">
              <img src="../../assets/images/icons/graph.png" alt="Templates" />
            </div>
            <h4>Smart Features</h4>
            <p>
              Attachments, templates, notifications, and full message history
              cut down ticket resolution time dramatically.
            </p>
          </div>
        </b-col>
      </b-row>

      <div
        class="image-showcase"
        data-aos="fade-up"
        data-aos-delay="400"
        data-aos-duration="1000"
      >
        <video autoplay loop muted playsinline>
          <source
            src="../../assets/images/messaging-demo.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      <div
        class="pricing-info"
        data-aos="fade-up"
        data-aos-delay="400"
        data-aos-duration="1000"
      >
        <div class="pricing-badge">
          <span class="trial">30-Day Free Trial</span>
          <span class="divider">•</span>
          <span class="free-plan">50 Free Tickets/Month</span>
          <span class="divider">•</span>
          <span class="price">From $0.10/ticket</span>
        </div>
      </div>

      <div
        class="cta-section"
        data-aos="fade-up"
        data-aos-delay="400"
        data-aos-duration="1000"
      >
        <a
          href="https://app.fulfillin.com"
          target="_blank"
          class="cta-button primary"
        >
          Start Free Trial
        </a>
        <a
          href="https://help.fulfillin.com/en/articles/51726-general-information-multi-channel-messaging-app-for-mirakl"
          target="_blank"
          class="cta-button secondary"
        >
          Learn More
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  name: 'Messaging',
  components: {
    BRow,
    BCol,
  },
}
</script>

<style lang="scss" scoped>
.messaging {
  background: linear-gradient(135deg, #1b1c1e 0%, #2d2f33 50%, #1b1c1e 100%);
  padding: 50px 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, transparent, darkorange, transparent);
  }

  .container {
    text-align: center;
    position: relative;
    z-index: 1;
  }

  .new-badge {
    display: inline-block;
    margin-bottom: 12px;

    span {
      background: darkorange;
      color: white;
      padding: 6px 18px;
      border-radius: 50px;
      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 2px;
      text-transform: uppercase;
      box-shadow: 0 4px 15px rgba(255, 140, 0, 0.4);
    }
  }

  h1 {
    font-family: 'Poppins', sans-serif;
    font-size: 40px;
    color: white;
    margin-bottom: 12px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);

    .highlight {
      color: darkorange;
    }

    @media (max-width: 768px) {
      font-size: 28px;
    }
  }

  h3 {
    font-family: 'Barlow', sans-serif;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.85);
    max-width: 700px;
    margin: 0 auto 30px;
    line-height: 1.5;

    @media (max-width: 768px) {
      font-size: 16px;
      padding: 0 20px;
    }
  }

  .features-row {
    margin-bottom: 30px;
  }

  .feature-card {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 140, 0, 0.2);
    border-radius: 12px;
    padding: 20px 18px;
    margin: 8px;
    transition: all 0.3s ease;
    height: 100%;
    min-height: 200px;

    &:hover {
      transform: translateY(-5px);
      border-color: darkorange;
      box-shadow: 0 10px 30px rgba(255, 140, 0, 0.2);
    }

    .icon-wrapper {
      width: 50px;
      height: 50px;
      background: darkorange;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 12px;

      img {
        width: 24px;
        height: 24px;
        filter: brightness(0) invert(1);
      }
    }

    h4 {
      font-family: 'Barlow', sans-serif;
      font-size: 16px;
      color: white;
      margin-bottom: 8px;
      font-weight: bold;
    }

    p {
      font-family: 'Open Sans', sans-serif;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 1.5;
      margin: 0;
    }
  }

  .image-showcase {
    margin: 30px auto;
    max-width: 900px;

    img,
    video {
      width: 100%;
      object-fit: cover;
      border-radius: 12px;
      box-shadow: 0 15px 50px rgba(0, 0, 0, 0.5);
      border: 1px solid rgba(255, 140, 0, 0.2);
    }
  }

  .pricing-info {
    margin-bottom: 20px;

    .pricing-badge {
      display: inline-flex;
      align-items: center;
      gap: 12px;
      background: rgba(255, 140, 0, 0.1);
      border: 1px solid rgba(255, 140, 0, 0.3);
      border-radius: 50px;
      padding: 10px 24px;

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 8px;
        padding: 20px 30px;

        .divider {
          display: none;
        }
      }

      span {
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        color: white;
      }

      .trial {
        color: darkorange;
        font-weight: bold;
      }

      .divider {
        color: rgba(255, 255, 255, 0.3);
      }

      .price {
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .cta-section {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;

    .cta-button {
      display: inline-block;
      padding: 12px 32px;
      border-radius: 50px;
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      font-weight: bold;
      text-decoration: none;
      transition: all 0.3s ease;
      text-transform: uppercase;
      letter-spacing: 1px;

      &.primary {
        background: darkorange;
        color: white;
        box-shadow: 0 4px 20px rgba(255, 140, 0, 0.4);

        &:hover {
          background: #ff9500;
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(255, 140, 0, 0.5);
        }
      }

      &.secondary {
        background: transparent;
        color: white;
        border: 2px solid rgba(255, 255, 255, 0.3);

        &:hover {
          border-color: white;
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
}
</style>
